import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { NotificationManager } from 'react-notifications';

/*** components ***/
import {Lid} from "./Lid";
import {Sleeve} from "./Sleeve";

/*** helpers ***/
import {sleveesList} from "./sleveesList";

export default class OptionsArea extends Component{
    constructor(props){
        super(props);
        this.state = {
            dimensions : []
        }
    }
    componentDidUpdate(prevProps){
        if(prevProps.buildValues.lids !== this.props.buildValues.lids){
            const innerArea = document.body.getElementsByClassName("inner-plan-step-2")[0].clientWidth;
            let koef;
            if(this.props.currentStep === 2 || this.props.currentStep === 3){
                koef = innerArea / this.props.lengthOfArea;
            }else{
                koef = innerArea / this.props.widthOfArea;
            }
            const dimensionsOfLids = this.props.buildValues.lids.map((item) => {
                return {
                    width : koef * item.length,
                    height : koef * item.height
                }
            });
            this.setState({
                dimensions : dimensionsOfLids
            })
        }

    }

    componentDidMount(){
        const innerArea = document.body.getElementsByClassName("inner-plan-step-2")[0].clientWidth;
        let koef;
        if(this.props.currentStep === 2 || this.props.currentStep === 3){
            koef = innerArea / this.props.lengthOfArea;
        }else{
            koef = innerArea / this.props.widthOfArea;
        }
        const dimensionsOfLids = this.props.buildValues.lids.map((item) => {
                return {
                    width : koef * item.length,
                    height : koef * item.height
                }
        });
        this.setState({
            dimensions : dimensionsOfLids
        });
    }

    nextStep = (e) => {
        if((this.props.height % 5)){
           e.preventDefault();
           NotificationManager.error("Bitte die Masse in 5cm Abständen eingeben");
        }
        if(this.props.buildValues.duplicateSide){
            const areaLength = this.props.nextStep - 1 <=3 ? this.props.lengthOfArea : this.props.widthOfArea;
            this.props.duplicateSide(+this.props.nextStep - 3, this.props.height, areaLength);
        }

    };
    render(){
        const sides = ["ANSICHT A","ANSICHT B", "ANSICHT C", "ANSICHT D", "KONTROLLE"];
        const nextStep = this.props.buildValues.duplicateSide ? this.props.nextStep + 1 : this.props.nextStep;
        const nextSide = this.props.buildValues.duplicateSide ? sides[this.props.nextStep - 1] : sides[this.props.nextStep - 2];

        return(
            <div className="options-area-step-2">
                <div className="wrapper-options-area-header-step-2">
                    {/* keep div to sustain current layout todo fix layout later */}
                </div>
                <div className="sleeves-list-area-step-2">
                    <h2 className="sleeves-header-step-2">
                        DRAG & DROP ENDMUFFEN
                    </h2>
                    <ul className="sleeves-list-step-2">
                        {sleveesList.map((item, index) => {
                            return (
                               <Sleeve
                                    key = {index}
                                    background = {item.color}
                                    id = {item.color}
                                    text = {item.text}
                                    currentStep = {this.props.currentStep}
                               />
                            )
                        })}
                    </ul>
                </div>
                <h2 className={"lid-header-step-2"}>DRAG & DROP AUSSPARUNGEN (Zentimeter)</h2>
                <div className="wrapper-lid-step-2">
                    {this.props.buildValues.lids.map((item, index) => {
                        return <Lid
                            key = {index}
                            value = {item.sagex}
                            changeInputValue = {this.props.changeInputValue}
                            dataInputNumber = {index}
                            currentStep={this.props.currentStep}
                            index = {index}
                            width = {this.state.dimensions[index] ? this.state.dimensions[index].width : null}
                            height = {this.state.dimensions[index] ? this.state.dimensions[index].height : null}
                            deleteLid = {this.props.deleteLid}
                            deleteFromPlan = {this.props.deleteFromPlan}
                            dataInputName = "sagex"
                            dataInputLid = {true}
                            dataParams = {{
                                height : item.height,
                                length : item.length
                            }}
                        />
                    })}
                </div>
                <div className="options-area-settings-step-2">
                    <div className="wrapper-options-area-add-lid-step-2">
                        <div className={"options-area-add-lid-step-2"} onClick = {this.props.addLid}>
                            + Aussparung hinzufügen
                        </div>
                    </div>
                    {!((this.props.nextStep - 1)%2) ?
                        <div className={"wrapper-options-duplicate-opposite-side"}>
                            <label
                                htmlFor="duplicate-checkbox"
                                className="lid-icon-sagex-name-step-2">
                                    Angabe widerspiegeln auf {sides[this.props.nextStep - 2]}
                            </label>
                            <input
                                type="checkbox"
                                id = "duplicate-checkbox"
                                className={"lid-icon-sagex-value-step-2"}
                                data-input-name = {"duplicateSide"}
                                onChange={this.props.changeInputValue}
                                checked = {this.props.buildValues.duplicateSide}
                            />
                        </div> :
                        null
                    }

                </div>
                <div className="next-button-area-step-2">
                    <Link to={`/step/${this.props.prevStep}`}>
                        <button className={"next-step-step-2 back-button-step-2"}>
                            ZURÜCK
                        </button>
                    </Link>
                    <Link to={`/step/${nextStep}`}>
                        <button className={`next-step-step-2 next-button-step-2 ${!(this.props.height % 5) ? null : "disable-next-step-1"}`} onClick = {this.nextStep}>
                            WEITER ZUR {nextSide} >>
                        </button>
                    </Link>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/steps/BuildSteps/OptionsArea/OptionsArea.js